export const RAG_META = {
  green: { label: "Low Risk", cls: "rag-green", dot: "rag-dot-green", ring: "ring-emerald-600/60" },
  yellow: { label: "Caution", cls: "rag-yellow", dot: "rag-dot-yellow", ring: "ring-yellow-600/60" },
  amber: { label: "Elevated", cls: "rag-amber", dot: "rag-dot-amber", ring: "ring-orange-600/60" },
  red: { label: "Critical", cls: "rag-red", dot: "rag-dot-red", ring: "ring-rose-600/60" },
};

export function ragClasses(rag) {
  return RAG_META[rag]?.cls || "rag-green";
}
